import { useEffect, useMemo, useState } from "react";
import Aside from "../../components/aside/aside.component";
import Footer from "../../components/footer/footer.component";
import Header from "../../components/header/header.component";
import { Link, useLocation } from "react-router-dom";
import PaymentFormModal from "./payment-form.modal";
import usePeriod from "../../hooks/period.use";
import { LoanPaymentService } from "../../services/operation/loan-payment";
import { UtilsService } from "../../services/utils";

function PaymentsPage() {
  const { currentPeriod } = usePeriod();
  const { state } = useLocation();

  const [list, setList] = useState<any[]>([]);

  const [showModal, setShowModal] = useState({
    data: null,
    show: false,
  });

  const totalDepositos = useMemo(() => {
    return list
      .filter((l) => l.type === "capital")
      .reduce((a, b) => a + b.amount, 0);
  }, [list]);

  const totalIntereses = useMemo(() => {
    return list
      .filter((l) => l.type === "interes")
      .reduce((a, b) => a + b.amount, 0);
  }, [list]);

  const handleModal = (refresh?: boolean) => {
    if (refresh) {
      getList();
    }
    setShowModal({ data: null, show: false });
  };

  const getList = async () => {
    const data = await LoanPaymentService.list(state.loan._id);
    setList(data);
  };  

  useEffect(() => {
    if (state.loan) {
      getList();
    }
  }, [state]);

  return (
    <>
      <div className="d-flex flex-column flex-root">
        <div className="page d-flex flex-row flex-column-fluid">
          <Aside />
          <div
            className="wrapper d-flex flex-column flex-row-fluid"
            id="kt_wrapper"
          >
            <Header />
            <div
              className="content fs-6 d-flex flex-column flex-column-fluid"
              id="kt_content"
            >
              <div className="toolbar" id="kt_toolbar">
                <div className="container-fluid d-flex flex-stack flex-wrap flex-sm-nowrap">
                  <div className="d-flex flex-column align-items-start justify-content-center flex-wrap me-2">
                    <h1 className="text-gray-900 fw-bold my-1 fs-2">
                      Dépositos a {state.loan.loan_credit.name}
                      <small className="text-muted fs-6 fw-normal ms-1" />
                    </h1>
                    <ul className="breadcrumb fw-semibold fs-base my-1">
                      <li className="breadcrumb-item text-muted">Operación</li>
                      <li className="breadcrumb-item text-muted">
                        <Link
                          to={".."}
                          className="text-muted text-hover-primary"
                        >
                          Prestamos y créditos
                        </Link>
                      </li>
                      <li className="breadcrumb-item text-gray-900">
                        Dépositos
                      </li>
                    </ul>
                  </div>
                  <div className="d-flex align-items-center flex-nowrap text-nowrap py-1">
                    <Link to=".." className="btn btn-secondary me-4">
                      <i className="ki-duotone ki-left"></i> Regresar
                    </Link>
                    <button
                      className="btn btn-primary"
                      onClick={() => setShowModal({ data: null, show: true })}
                    >
                      <i className="ki-duotone ki-plus"></i> Agregar déposito
                    </button>
                  </div>
                </div>
              </div>

              <div className="container-xxl mb-5">
                <div className="row">
                  <div className="col-3">
                    <div className="card h-100">
                      <div className="card-body p-9">
                        <div className="fs-2x fw-bold">
                          ${" "}
                          {UtilsService.numberFormat(
                            state.loan.amount + state.loan.total_interest
                          )}
                        </div>
                        <div className="fw-bold">
                          $ {UtilsService.numberFormat(state.loan.amount)} + ${" "}
                          {UtilsService.numberFormat(state.loan.total_interest)}
                        </div>
                        <div className="fs-4 fw-semibold text-gray-500">
                          Total de deuda contraída
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="card h-100">
                      <div className="card-body p-9">
                        <div className="fs-2x fw-bold">
                          $ {UtilsService.numberFormat(totalIntereses)}
                        </div>
                        <div className="fs-4 fw-semibold text-gray-500">
                          Pago de intereses
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="card h-100">
                      <div className="card-body p-9">
                        <div className="fs-2x fw-bold">
                          $ {UtilsService.numberFormat(totalDepositos)}
                        </div>
                        <div className="fs-4 fw-semibold text-gray-500">
                          Pago a capital
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="card h-100">
                      <div className="card-body p-9">
                        <div className="fs-2x fw-bold">
                          ${" "}
                          {UtilsService.numberFormat(
                            state.loan.amount +
                              state.loan.total_interest -
                              (totalDepositos + totalIntereses)
                          )}
                        </div>
                        <div className="fs-4 fw-semibold text-gray-500">
                          Total para liquidar deuda
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="post fs-6 d-flex flex-column-fluid" id="kt_post">
                <div className="container-xxl">
                  <div className="card">
                    <div className="card-header border-0 pt-6">
                      <div className="card-title">
                        <div className="d-flex align-items-center position-relative my-1">
                          <i className="ki-duotone ki-magnifier fs-3 position-absolute ms-5">
                            <span className="path1" />
                            <span className="path2" />
                          </i>
                          <input
                            className="form-control form-control-solid w-250px ps-13"
                            placeholder="Buscar usuario"
                            type="text"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="card-body py-4">
                      <div
                        className="dt-container dt-bootstrap5 dt-empty-footer"
                      >
                        <div className="table-responsive" id="">
                          <table
                            className="table align-middle table-row-dashed fs-6 gy-5 dataTable"
                            id="kt_table_users"
                          >
                            <thead>
                              <tr
                                className="text-start text-muted fw-bold fs-7 text-uppercase gs-0"
                                role="row"
                              >
                                <th
                                  aria-label="Role: Activate to sort"
                                  className="min-w-125px "
                                  colSpan={1}
                                  rowSpan={1}
                                  tabIndex={0}
                                >
                                  <span
                                    className=""
                                    
                                  >
                                    Concepto
                                  </span>
                                  <span className="dt-column-order" />
                                </th>
                                <th
                                  aria-label="Last login: Activate to sort"
                                  className="min-w-125px "
                                  colSpan={1}
                                  rowSpan={1}
                                  tabIndex={0}
                                >
                                  <span
                                    className=""
                                    
                                  >
                                    Fecha de depósito
                                  </span>
                                  <span className="dt-column-order" />
                                </th>
                                <th
                                  aria-label="Joined Date: Activate to sort"
                                  className="min-w-125px "
                                  colSpan={1}
                                  rowSpan={1}
                                  tabIndex={0}
                                >
                                  <span
                                    className=""
                                    
                                  >
                                    Tipo de pago
                                  </span>
                                  <span className="dt-column-order" />
                                </th>
                                <th
                                  aria-label="Joined Date: Activate to sort"
                                  className="min-w-125px "
                                  colSpan={1}
                                  rowSpan={1}
                                  tabIndex={0}
                                >
                                  <span
                                    className=""
                                    
                                  >
                                    Monto
                                  </span>
                                  <span className="dt-column-order" />
                                </th>
                                <th
                                  aria-label="Joined Date: Activate to sort"
                                  className="min-w-125px "
                                  colSpan={1}
                                  rowSpan={1}
                                  tabIndex={0}
                                >
                                  <span
                                    className=""
                                    
                                  >
                                    Fecha de creación
                                  </span>
                                  <span className="dt-column-order" />
                                </th>
                              </tr>
                            </thead>
                            <tbody className="text-gray-600 fw-semibold">
                              {list.map((row) => (
                                <tr key={row._id}>
                                  <td>
                                    <div className="d-flex flex-column">
                                      <p className="text-gray-800 m-0">
                                        {row.concept}
                                      </p>
                                    </div>
                                  </td>
                                  <td>
                                    {UtilsService.dateFormat(
                                      row.date,
                                      "DD/MM/YYYY"
                                    )}
                                  </td>
                                  <td>{row.type}</td>
                                  <td>
                                    $ {UtilsService.numberFormat(row.amount)}
                                  </td>
                                  <td>
                                    {UtilsService.dateFormat(row.created_at)}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                            <tfoot />
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>

      <PaymentFormModal
        show={showModal.show}
        data={showModal.data}
        loan={state.loan}
        setShow={handleModal}
      />
    </>
  );
}

export default PaymentsPage;
